import api from './api'

export interface Manual {
  id: string
  title: string
  description: string | null
  fileName: string
  fileUrl: string
  fileSize: number
  mimeType: string
  sortOrder: number
  isActive: boolean
  createdAt: string
  updatedAt: string
}

export interface CreateManualData {
  title: string
  description?: string
  fileName: string
  fileUrl: string
  fileSize: number
  mimeType?: string
  sortOrder?: number
  isActive?: boolean
}

export interface UpdateManualData {
  title?: string
  description?: string | null
  fileName?: string
  fileUrl?: string
  fileSize?: number
  mimeType?: string
  sortOrder?: number
  isActive?: boolean
}

export interface ManualsResponse {
  manuals: Manual[]
  total: number
}

// Obtener manuales activos (para empleados)
export const getActiveManuals = async (): Promise<ManualsResponse> => {
  const response = await api.get('/manuals/active')
  return response.data
}

// Obtener todos los manuales (admin)
export const getAllManuals = async (filters?: { isActive?: boolean; search?: string }): Promise<ManualsResponse> => {
  const response = await api.get('/manuals', { params: filters })
  return response.data
}

// Obtener manual por ID
export const getManualById = async (id: string): Promise<Manual> => {
  const response = await api.get(`/manuals/${id}`)
  return response.data
}

// Crear manual
export const createManual = async (data: CreateManualData): Promise<Manual> => {
  const response = await api.post('/manuals', data)
  return response.data
}

// Actualizar manual
export const updateManual = async (id: string, data: UpdateManualData): Promise<Manual> => {
  const response = await api.put(`/manuals/${id}`, data)
  return response.data
}

// Eliminar manual
export const deleteManual = async (id: string): Promise<void> => {
  await api.delete(`/manuals/${id}`)
}

// Toggle activo/inactivo
export const toggleManual = async (id: string): Promise<Manual> => {
  const response = await api.patch(`/manuals/${id}/toggle`)
  return response.data
}

// Actualizar orden
export const updateManualSort = async (id: string, sortOrder: number): Promise<Manual> => {
  const response = await api.patch(`/manuals/${id}/sort`, { sortOrder })
  return response.data
}

// Helper para formatear tamaño de archivo
export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes'
  const k = 1024
  const sizes = ['Bytes', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
}

// Helper para convertir archivo a base64
export const fileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result as string)
    reader.onerror = (error) => reject(error)
  })
}
